import apiClient from './apiClient';

class AuthService {
  async getCurrentUser() {
    try {
      const response = await apiClient.get('/api/auth/me');
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        // User is not authenticated
        return null;
      }
      throw error;
    }
  }

  async logout() {
    try {
      await apiClient.post('/api/auth/logout');
      // Clear any local storage or session data if needed
      localStorage.removeItem('user');
      sessionStorage.clear();
    } catch (error) {
      // Even if logout fails on server, clear local data
      localStorage.removeItem('user');
      sessionStorage.clear();
      throw error;
    }
  }

  // Google OAuth login - handled by redirecting to backend
  initiateGoogleLogin() {
    const runtimeURL = window.ENV?.REACT_APP_API_BASE_URL;
    const envURL = process.env.REACT_APP_API_BASE_URL;
    const baseURL = (runtimeURL && !runtimeURL.includes('PLACEHOLDER')) 
      ? runtimeURL 
      : (envURL || 'http://localhost:3001');
    
    window.location.href = `${baseURL}/api/auth/google`;
  }

  // Check if user has required role
  hasRole(user, requiredRole) {
    if (!user) return false;
    if (user.role === 'Admin') return true; // Admin has all permissions
    return user.role === requiredRole;
  }

  // Check if user can access entity
  canAccessEntity(user, entityId) {
    if (!user) return false;
    if (user.role === 'Admin') return true; // Admin can access all entities
    if (!user.accessibleEntities) return false; // No accessible entities
    return user.accessibleEntities.some(entity => entity.id === entityId);
  }

  // Check if user can approve (not their own proposal)
  canApprove(user, proposerId) {
    if (!user) return false;
    if (user.id === proposerId) return false; // Can't approve own proposal
    return user.role === 'Admin' || user.role === 'Manager';
  }
}

export const authService = new AuthService();
